import { render, staticRenderFns } from "./workDetail.vue?vue&type=template&id=2a05babf&scoped=true"
import script from "./workDetail.vue?vue&type=script&lang=js"
export * from "./workDetail.vue?vue&type=script&lang=js"
import style0 from "./workDetail.vue?vue&type=style&index=0&id=2a05babf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a05babf",
  null
  
)

export default component.exports